import { stateAbstract, actionsAbstract, mutationsAbstract } from '@/store/abstract'

const state = {
  ...stateAbstract,
  providersDetail: {},
  providersCount: null,
  providersList: [],
  sourcesDetail: {},
  sourcesCount: null,
  sourcesList: [],
  paymentsDetail: {},
  paymentsCount: null,
  paymentsList: [],
  refundsDetail: {},
  refundsCount: null,
  refundsList: []
}

export default {
  namespaced: true,
  state,
  actions: actionsAbstract,
  mutations: mutationsAbstract
}
